define('app/dashboard/dialogs/AddDashboardDialogView',['require','app/editor/dialogs/SaveDialogView','app/models/Dashboard','config','glu/util','glu/http','glu/$','hbs!./AddDashboardDialogView.hbs'],function(require) {
	'use strict';

	var SaveDialogView = require('app/editor/dialogs/SaveDialogView'),
		Dashboard = require('app/models/Dashboard'),
		config = require('config'),
		_ = require('glu/util'),
		http = require('glu/http'),
		$ = require('glu/$');

	var view = SaveDialogView.extend({

		http: http,

		dialogTitle: 'Create a Dashboard',

		template: require('hbs!./AddDashboardDialogView.hbs'),

		ui: {
			$publicFieldId: '#dashboard-as-public',
			$selectedDashboard: '[name="dashboard"]',
			$createDiv: '[name="create-dash-div"]',
			$selectDiv: '[name="select-dash-div"]'
		},

		events: {
			'change [name="dashboard"]': 'changeDashboard',
			'change [name="dashboard-type"]': 'updateMode',
			'keypress': 'keyAction'
		},

		getClass: function() {
			return 'modal-add-dashboard';
		},

		initialize: function(dashboards) {
			this.publicDashboards = dashboards;
		},

		onRender: function() {

			this.updateMode1();

			// Create combobox
			this.ui.$selectedDashboard.comboBox({
				placeholder: 'Select a dashboard'
			});

			// Toggle upload/create mode
			if (this.createReportMode) {
				$('input[value="create-dashboard"]').prop('checked', true);
			} else {
				$('input[value="import-dashboard"]').prop('checked', true);
			}
		},

		isPublic: function() {
			return this.$el.find(this.ui.$publicFieldId).is(':checked');
		},

		selectableOptions: function() {
			// get all public domains that user can view
			return _.map(this.publicDashboards, function(d) {
				return {
					value: d.id,
					label: d.name + ' - ' + d.owner
				};
			});
		},

		updateMode1: function() {
			this.createDashboardMode = true;
			this.ui.$selectDiv.hide();
			this.ui.$createDiv.show();
		},

		updateMode2: function() {
			this.createDashboardMode = false;
			this.ui.$createDiv.hide();
			this.ui.$selectDiv.show();
		},

		updateMode: function(e) {
			if ($(e.target).val() === 'create-dashboard') {
				this.createDashboardMode = true;
				this.ui.$selectDiv.hide();
				this.ui.$createDiv.show();
			} else {
				this.createDashboardMode = false;
				this.ui.$createDiv.hide();
				this.ui.$selectDiv.show();
			}
		},

		isCreateDashboard: function() {
			return this.createDashboardMode;
		},

		addDashboard: function(dashboardId) {
			$.ajax(config.apiRoot + 'service/publicdashboards', {
				type: 'POST',
				context: this,
				contentType: 'application/json',
				data: dashboardId
			}).done(function() {
				this.trigger('addDashboard', dashboardId);
			});
		},

		save: function() {
			if (this.createDashboardMode) {
				if (this.isValid()) {
					// create a new dashboards
					var dashboard = new Dashboard();
					dashboard.set('name', this.uigetName());
					dashboard.set('description', this.uigetDescription());
					dashboard.set('dashboardType', 'CUSTOM');
					dashboard.set('layout', 'BASIC');
					if (this.isPublic() === true) {
						dashboard.set('isPrivate', false);
					} else {
						dashboard.set('isPrivate', true);
					}

					$.ajax(config.apiRoot + 'service/dashboards', {
						type: 'POST',
						context: this,
						contentType: 'application/json',
						data: JSON.stringify(dashboard)
					}).done(function(data) {
						this.trigger('addDashboard', data.id);
					});
					return dashboard;
				}
			} else {
				var dashboardId = this.$el.find(this.ui.$selectedDashboard).val();
				this.addDashboard(dashboardId);
			}
		},

		keyAction: function(e) {
			var code = e.keyCode || e.which;

			// Enter pressed
			if (code === 13) {
				e.preventDefault();
				this.save();
			}
		}
	});

	return view;
});

